import firebase from 'firebase/compat/app';
import { getFirestore} from "firebase/firestore";
import { initializeApp } from "firebase/app";

export const app = initializeApp({
  apiKey: "AIzaSyDrURjHmZIGUJIglNS_isSnyaAMz5teE_I",
  authDomain: "gb-toc.firebaseapp.com",
  databaseURL: "https://gb-toc-default-rtdb.firebaseio.com",
  projectId: "gb-toc",
  storageBucket: "gb-toc.appspot.com",
  messagingSenderId: "323402042357",
  appId: "1:323402042357:web:7fcaeea2adfc48ba1beebc"
});

export const db = getFirestore(app);